import { MyContextProvider } from "../../ra-lb-tools/components/myContext";
import { LockerUsageShow, RawLockerUsageList } from "../billing/lockerUsage";

const removedCustomFields = ["tower.isForTest"];

export const OrgLockerUsagesList = (props) => {
  return (
    <RawLockerUsageList
      title="My Locker Usages"
      dataGridProps={{ bulkActionButtons: false }}
      removedCustomFields={removedCustomFields}
      {...props}
    />
  );
};

export const OrgLockerUsagesShow = () => {
  return (
    <MyContextProvider value={{ removedCustomFields }}>
      <LockerUsageShow />
    </MyContextProvider>
  );
};
